export default "__VITE_ASSET__Dc5JStuZ__"